import { DatePicker, Spin } from "antd";
import styles from "../styles/KpisUI.module.css";
import cx from "classnames";

const DateFilters = ({ active, handleActiveDay, activeCard, handleRangesDates, loading }) => {
  let filters = [];
  if (activeCard.key !== 6) {
    filters = [
      { key: "0", label: "Hoy" },
      { key: "-1", label: "Ayer" },
      { key: "-7", label: "Últimos 7 días" },
      { key: "-30", label: "Últimos 30 días" },
      { key: "-60", label: "Mes pasado" },
    ];
  }
  if (activeCard.key === 6) {
    filters = [
      { key: "7", label: "Semana actual" },
      { key: "-30", label: "Últimos 30 días" },
      { key: "-180", label: "Último semestre" },
    ];
  }
  return (
    <div className={styles.container}>
      <div className={styles.tabs}>
        {filters.map((item) => (
          <span
            key={item.key}
            className={cx(styles.tab, active === item.key && styles.activeTab, loading && styles.disabledTab)}
            onClick={() => {
              if (!loading) {
                handleActiveDay(item.key);
              }
            }}
          >
            {item.label}
          </span>
        ))}
        {loading && (
          <span className={styles.dateLoader}>
            <Spin size="small" />
          </span>
        )}
      </div>
      <div className={styles.pickers}>
        <DatePicker.RangePicker
          style={{ borderRadius: "8px" }}
          onChange={handleRangesDates}
          disabled={loading}
        />
      </div>
    </div>
  );
};

export default DateFilters;
